import React, { useEffect, useState } from "react";
import {
  Typography,
  Row,
  Col,
  Table,
  Button,
  Space,
  message,
  Spin,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import dataService from "../networks/api/service/dataService";
import { PieChart, Pie, Tooltip, Cell, Legend } from "recharts";
import CustomTable from "../components/TableComponent/CustomTable";
import { LeftOutlined } from "@ant-design/icons";

const { Title } = Typography;

const SurveyResponseList = () => {
  const { id } = useParams();
  const [genderData, setGenderData] = useState([]);

  const [surveyData, setSurveyData] = useState(null);
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch survey data including questions and responses
  const getSurveyResponses = async () => {
    try {
      const response = await dataService.getDataFromSurveyId(id);
      if (response.code === 200) {
        setSurveyData(response.data);
        setResponses(response.data.responses);
      } else {
        message.error("Something went wrong while getting survey responses");
      }
    } catch (e) {
      message.error("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSurveyResponses();
  }, [id]);

  // Dynamically create columns for each question
  const columns = [
    {
      title: "Sl. No.",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
      width: "5%",
      textAlign: "center",
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    // },
    ...(surveyData?.question?.map((question, index) => ({
      title: (
        <div
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            textAlign: "center", // Optional, if you want to center align
          }}
        >
          {question.question}
        </div>
      ),
      dataIndex: `answer_${index}`,
      key: `answer_${index}`,
      render: (text) => (
        <div
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            width: 150,
          }}
        >
          {text || "N/A"}
        </div>
      ),
      width: "30%",

      ellipsis: false, // Ensures that text does not get truncated
    })) || []),
  ];

  // Prepare data for the table
  const tableData = responses.map((response, index) => {
    const answers = response.answers.reduce((acc, answer, idx) => {
      acc[`answer_${idx}`] = answer.answer; // Map each answer to the corresponding column
      return acc;
    }, {});
    return {
      ...response,
      index,
      email: response.email,
      ...answers, // Add answers dynamically as separate columns
    };
  });

  useEffect(() => {
    if (surveyData && responses.length > 0) {
      const genderCounts = responses.reduce(
        (acc, response) => {
          const genderAnswer = response.answers.find(
            (ans) =>
              surveyData?.question.find(
                (q) => q.type === "radio" && q.question === "gender"
              )?._id === ans.questionId
          )?.answer;

          // Normalize the gender answer to lowercase
          const normalizedGenderAnswer = genderAnswer
            ? genderAnswer.toLowerCase()
            : "";

          // Check if the answer starts with 'm' for male or 'f' for female
          if (normalizedGenderAnswer.startsWith("m")) acc.male += 1;
          if (normalizedGenderAnswer.startsWith("f")) acc.female += 1;
          if (
            normalizedGenderAnswer &&
            !normalizedGenderAnswer.startsWith("m") &&
            !normalizedGenderAnswer.startsWith("f")
          )
            acc.other += 1;

          return acc;
        },
        { male: 0, female: 0, other: 0 }
      );

      setGenderData([
        { name: "Male", value: genderCounts.male },
        { name: "Female", value: genderCounts.female },
        { name: "Other", value: genderCounts.other },
      ]);
    }
  }, [surveyData, responses]);

  const COLORS = ["#0088FE", "#FF8042", "#FFBB28"]; // Colors for pie chart

  return (
    <Row justify="center" style={{ width: "100%" }}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ width: "100%" }}>
      <Button
        type="primary"
        icon={<LeftOutlined />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: "20px"}}
      >
        Go Back
      </Button>
        <Title
          level={3}
          style={{
            textAlign: "center",
            color: "#1890ff",
            marginBottom: "1rem",
          }}
        >
          Survey Responses
        </Title>

        {loading ? (
          <Spin
            size="large"
            tip="Loading responses..."
            style={{ display: "block", margin: "0 auto" }}
          />
        ) : (
          <CustomTable
            dataSource={tableData}
            columns={columns}
            rowKey="_id"
            pagination={{ pageSize: 5 }}
            bordered
            size="middle"
            style={{
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              backgroundColor: "#fff",
              width: "100%", // Ensures the table takes full width
              overflowX: "auto", // Allows horizontal scroll for smaller screens
              whiteSpace: "nowrap",
            }}
            scroll={{ x: 800 }} // Adjusted for more dynamic columns
          />
        )}
        <Row justify="center" style={{ marginTop: "2rem" }}>
          <Col
            xs={22}
            sm={22}
            md={12}
            lg={8}
            xl={6}
            style={{ textAlign: "center" }}
          >
            {/* {genderData.length > 0 ? (
              <PieChart width={300} height={300}>
                <Pie
                  data={genderData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={70}
                  fill="#8884d8"
                  label
                >
                  {genderData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            ) : (
              <p>No gender data available to display</p>
            )} */}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SurveyResponseList;
